import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string, textColor?: string }>`
  background: ${(p) => p.color || "#1963d1"};
  color: ${(p) => (p.textColor ? "#2E186A" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 2px solid transparent;
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

  &:hover,
  &:active,
  &:focus {
    color: #1963d1;
    border: 2px solid #1963d1;
    background-color: #fff;
  }
`;
